import { RefSelectProps, SelectProps } from 'antd'
import { useCustomInput } from 'shared/libs/hooks/useCustomInput'

import { useRef, useState } from 'react'

import CustomInput from 'shared/ui/Form/CustomInput/CustomInput'
import { Select } from 'shared/ui/Form/Select'

import './CustomSelectField.css'

export type CustomSelectFieldProps = SelectProps & {
  wrapperClassname?: string
  placeholderClassname?: string
  placeholder: string
  suffixClassname?: string
}

const CustomSelectField = ({
  placeholder,
  className,
  value,
  wrapperClassname,
  placeholderClassname,
  suffixClassname,
  ...props
}: CustomSelectFieldProps) => {
  const selectRef = useRef<RefSelectProps>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { isFocus, setIsFocus, handleBlur, handleFocus } = useCustomInput()
  const changeIsOpen = (isOpen: boolean) => {
    setTimeout(() => {
      setIsOpen(isOpen)
    })
  }
  return (
    <CustomInput
      open={() => setIsOpen(true)}
      value={value}
      childrenRef={selectRef}
      placeholder={placeholder}
      wrapperClassname={`!px-[0] !cursor-pointer ${wrapperClassname}`}
      placeholderClassname={placeholderClassname}
      isFocus={isFocus}
      setIsFocus={setIsFocus}
    >
      <Select
        open={isOpen}
        onDropdownVisibleChange={changeIsOpen}
        getPopupContainer={(triggerNode) => triggerNode}
        withPlaceholder={false}
        ref={selectRef}
        value={value}
        rootClassName={`customSelectField h-auto w-full ${className}`}
        onFocus={handleFocus}
        onBlur={handleBlur}
        suffixClassname={suffixClassname}
        {...props}
      />
    </CustomInput>
  )
}

export default CustomSelectField
